import { IPageFilter } from "../../store/queries/page-filter.interface";
import { UserFilters } from "./user.reducer";
import { User } from "./user.model";
import { itemSelector, listSelector, Qry } from "../query-facade";
import { VasState } from "../../store/store-type";
import { getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { createSelector } from "reselect";
import { getSortByFn } from "../../../core/util/utils";
import { MembershipQueryFactory } from "../membership/membership.queries";

export class UserPageFilter implements IPageFilter<User, UserFilters> {

    constructor(protected qry: Qry, protected membershipQueryFactory: MembershipQueryFactory) {

    }

    createSelector(itemsSelector: listSelector<User>, filterSelector: itemSelector<UserFilters>): (state: VasState) => Array<User> {
        return createSelector(
            itemsSelector,
            filterSelector,
            this.membershipQueryFactory.items,
            (users, filters, memberships) => {
                return users
                    .filter(getFilterBySearchTermFn(filters.searchTerm))
                    // - filter users that have a membership that contains the accessGroup filter value
                    .filter(user => {
                        if (filters.accessGroup === "*") return true;
                        return memberships
                            .filter(membership => membership.user === user.id)
                            .filter(membership => membership.accessGroups.indexOf(filters.accessGroup) !== -1)
                            .length;
                    })
                    // sort
                    .sort(getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, user: User) => {
                        switch (sortBy) {
                            case "name":
                                return user.name;
                            case "email":
                                return user.email;
                            case "mobile":
                                return user.mobile;
                            case "lastLogin":
                                return user.lastLogin;
                            default:
                                throw new Error(`invalid sort by "${sortBy}"`);
                        }
                    }));
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.page-filter.ts